<div class="partner-wrapper">
  <div class="hero card-glass mb-4">
    <div class="crumb">
      <a routerLink="/utilisateur/partenaire/dashboard" class="crumb-link"><i class="bi bi-arrow-left"></i> Retour au dashboard partenaire</a>
    </div>
    <p class="eyebrow">Spay · Partenaire</p>
    <h1 class="text-danger fw-bolder">Retrait sur compte</h1>
    <p class="lead">Traitez les retraits sécurisés pour vos clients.</p>
  </div>

  <div class="row g-3">
    <div class="col-lg-5">
      <div class="card card-glass h-100 p-3">
        <h5 class="mb-2">Effectuer un retrait</h5>
        <div class="alerts mb-2">
          <p *ngIf="succesmessageR" class="alert-text success">La transaction a été effectuée.</p>
          <p *ngIf="errorR1" class="alert-text danger">Code inexistant.</p>
          <p *ngIf="errorR2" class="alert-text danger">Erreur inattendue.</p>
          <p *ngIf="errorR3" class="alert-text danger">Solde commerçant insuffisant.</p>
          <p *ngIf="errorR4" class="alert-text danger">Montant non autorisé.</p>
          <p *ngIf="errorR5" class="alert-text danger">Solde client insuffisant.</p>
          <p *ngIf="errorR6" class="alert-text danger">Délai de validité du code écoulé.</p>
          <p *ngIf="errorR11" class="alert-text warning">Montant sensible: répétez exactement l'opération pour
            confirmer.</p>
          <p *ngIf="errorR12" class="alert-text danger">Code opérationnel invalide.</p>
          <p *ngIf="errorR13" class="alert-text danger">Décomposition des billets requise.</p>
          <p *ngIf="errorR14" class="alert-text danger">Le total des billets ne correspond pas au montant saisi.</p>
        </div>
        <form [formGroup]="retrait" #f1="ngForm" (ngSubmit)="makeRetrait(f1.value)" class="row g-3">
          <div class="col-md-12">
            <label class="form-label">Code de retrait</label>
            <input type="text" formControlName="codeRetrait" class="form-control" id="codeRetrait" placeholder="Code">
          </div>
          <div class="col-md-12">
            <label class="form-label">Montant</label>
            <input type="number" formControlName="montantRetrait" class="form-control" id="montantRetrait"
              placeholder="Montant du retrait">
          </div>
          <div class="col-md-12">
            <label class="form-label">Code opérationnel employé</label>
            <input type="text" formControlName="supervisorCode" class="form-control"
              placeholder="Code opérationnel employé">
            <small class="text-muted">Matricule: {{ matriculeEmploye || 'N/A' }}</small>
          </div>
          <div class="col-12">
            <label class="form-label">Décomposition billets (obligatoire)</label>
          </div>
          <div class="col-md-4">
            <label class="form-label">10 000</label>
            <input type="number" min="0" formControlName="d10000" class="form-control">
          </div>
          <div class="col-md-4">
            <label class="form-label">5 000</label>
            <input type="number" min="0" formControlName="d5000" class="form-control">
          </div>
          <div class="col-md-4">
            <label class="form-label">2 000</label>
            <input type="number" min="0" formControlName="d2000" class="form-control">
          </div>
          <div class="col-md-6">
            <label class="form-label">1 000</label>
            <input type="number" min="0" formControlName="d1000" class="form-control">
          </div>
          <div class="col-md-6">
            <label class="form-label">500</label>
            <input type="number" min="0" formControlName="d500" class="form-control">
          </div>
          <div class="col-12 d-grid">
            <button type="submit" class="btn btn-primary btn-pill" [disabled]="!retrait.valid || isSubmittingRetrait">
              {{ isSubmittingRetrait ? 'Traitement...' : 'Effectuer' }}
            </button>
          </div>
        </form>

        <div class="metrics mt-4">
          <h6 class="mb-2">Situation du compte</h6>
          <div class="metric-row" *ngFor="let m of [
            {label:'Solde du compte', value: soldeMensuel},
            {label:'Total dépôts', value: totalDepots},
            {label:'Total retrait', value: totalRetrait}
           
          ]">
            <span>{{m.label}}</span>
            <strong>{{m.value | currency:'FCFA'}}</strong>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-7">
      <div class="card card-glass p-3 h-100">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h5 class="mb-0">Synthèse mensuelle</h5>
        </div>
        <div class="row g-3">
          <div class="col-sm-6 col-xl-4" *ngFor="let m of depotMensualite">
            <div class="mini-card">
              <div class="mini-card-header">{{m.month}}/{{m.annee}}</div>
              <div class="mini-card-body">
                <div class="metric-row"><span>Solde du mois</span><strong>{{m.soldeMensuel | number:'1.0-0' }} {{ sigle
                    }}</strong>
                </div>
                <div class="metric-row"><span>Total dépôt</span><strong>{{m.depot + m.depotClient |
                    currency:'FCFA'}}</strong></div>
                <!--<div class="metric-row"><span>Bénéfice dépôt</span><strong>{{m.bDepot | number:'1.0-0' }} {{ sigle
                    }}</strong></div>-->
                <div class="metric-row"><span>Total retrait</span><strong>{{m.retrait | number:'1.0-0' }} {{ sigle
                    }}</strong></div>
                <!--<div class="metric-row"><span>Bénéfice retrait</span><strong>{{m.bRetrait | number:'1.0-0' }} {{ sigle
                    }}</strong>
                </div>-->
              </div>
            </div>
          </div>
          <div class="col-12" *ngIf="!depotMensualite || depotMensualite.length===0">
            <div class="mini-card text-center text-muted">Aucune donnée mensuelle.</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
